import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RangeInput',
  props: {
    value: null,
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    showPin: { type: Boolean, default: true },
    showLabel: { type: Boolean, default: true }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value?: number | number[], min: number, max: number, step: number, showPin: boolean, showLabel: boolean };





const rangeEl = ref();
const draggingKnob = ref<number | null>(null);
const knobValues = ref<number[]>(
	Array.isArray(props.value) ? [...props.value] : typeof props.value === 'number' ? [props.value] : []
);

watch(
	() => props.value,
	() => {
		knobValues.value = Array.isArray(props.value)
			? [...props.value]
			: typeof props.value === 'number'
			? [props.value]
			: [];
	}
);

const activeTrackStyle = computed(() => {
	const values = [...knobValues.value].sort((a, b) => a - b);

	if (values.length === 1) {
		const end = ((values[0] - props.min) / (props.max - props.min)) * 100;
		return {
			left: '0%',
			width: `${end}%`,
		};
	} else {
		const start = ((values[0] - props.min) / (props.max - props.min)) * 100;
		const end = ((values[values.length - 1] - props.min) / (props.max - props.min)) * 100;
		return {
			left: `${start}%`,
			width: `${end - start}%`,
		};
	}
});

const getKnobStyle = (val: number) => {
	const percent = ((val - props.min) / (props.max - props.min)) * 100;
	return { left: `${percent}%` };
};

const updateValueFromPosition = (x: number) => {
	const rect = rangeEl.value.getBoundingClientRect();
	const percent = Math.min(Math.max((x - rect.left) / rect.width, 0), 1);
	const rawVal = props.min + percent * (props.max - props.min);
	return Math.round(rawVal / props.step) * props.step;
};

const onDrag = (e: any) => {
	if (draggingKnob.value === null) return;
	const clientX = e.touches ? e.touches[0].clientX : e.clientX;
	const newVal = updateValueFromPosition(clientX);

	knobValues.value[draggingKnob.value] = newVal;
	knobValues.value = [...knobValues.value].sort((a, b) => a - b);
};

const stopDrag = () => {
	document.removeEventListener('mousemove', onDrag);
	document.removeEventListener('mouseup', stopDrag);
	document.removeEventListener('touchmove', onDrag);
	document.removeEventListener('touchend', stopDrag);

	emit('input', knobValues.value.length === 1 ? knobValues.value[0] : [...knobValues.value]);

	draggingKnob.value = null;
	document.body.style.cursor = 'default';
};

const startKnobDrag = (index: number) => {
	draggingKnob.value = index;
	document.addEventListener('mousemove', onDrag);
	document.addEventListener('mouseup', stopDrag);
	document.addEventListener('touchmove', onDrag);
	document.addEventListener('touchend', stopDrag);
	document.body.style.setProperty('cursor', 'grabbing', 'important');
};

const startDrag = (e: any) => {
	if (draggingKnob.value !== null) return;

	const clientX = e.touches ? e.touches[0].clientX : e.clientX;
	const newVal = updateValueFromPosition(clientX);

	let nearestIndex = 0;
	let minDist = Infinity;
	knobValues.value.forEach((v, i) => {
		const dist = Math.abs(v - newVal);
		if (dist < minDist) {
			minDist = dist;
			nearestIndex = i;
		}
	});

	knobValues.value[nearestIndex] = newVal;
	knobValues.value.sort((a, b) => a - b);

	startKnobDrag(nearestIndex);
};

return { __sfc: true,props, emit, rangeEl, draggingKnob, knobValues, activeTrackStyle, getKnobStyle, updateValueFromPosition, onDrag, stopDrag, startKnobDrag, startDrag }
}

})